export enum ApiRoutesInsights {
  NeverSoldProducts = "admin/products/never-sold",
  PriceInsights = "admin/products/with-price-insights",
  PriceInsightOrders = "admin/orders/items/with-price-insights",
  InventoryInsights = "admin/products/with-low-quantity"
}
